var map = {
	"./_sylvia.png": "./src/assets/img/new_alpha/characters/_sylvia.png",
	"./alfredo.png": "./src/assets/img/new_alpha/characters/alfredo.png",
	"./andrea.png": "./src/assets/img/new_alpha/characters/andrea.png",
	"./architetto.png": "./src/assets/img/new_alpha/characters/architetto.png",
	"./bianca.png": "./src/assets/img/new_alpha/characters/bianca.png",
	"./carmela.png": "./src/assets/img/new_alpha/characters/carmela.png",
	"./dario.png": "./src/assets/img/new_alpha/characters/dario.png",
	"./giovanni.png": "./src/assets/img/new_alpha/characters/giovanni.png",
	"./giulio.png": "./src/assets/img/new_alpha/characters/giulio.png",
	"./jack.png": "./src/assets/img/new_alpha/characters/jack.png",
	"./lino.png": "./src/assets/img/new_alpha/characters/lino.png",
	"./lucia.png": "./src/assets/img/new_alpha/characters/lucia.png",
	"./primo.png": "./src/assets/img/new_alpha/characters/primo.png",
	"./quattro.png": "./src/assets/img/new_alpha/characters/quattro.png",
	"./quattro2.png": "./src/assets/img/new_alpha/characters/quattro2.png",
	"./rocco.png": "./src/assets/img/new_alpha/characters/rocco.png",
	"./sophie.png": "./src/assets/img/new_alpha/characters/sophie.png",
	"./sylvia.png": "./src/assets/img/new_alpha/characters/sylvia.png",
	"./trainer.png": "./src/assets/img/new_alpha/characters/trainer.png",
	"./user.png": "./src/assets/img/new_alpha/characters/user.png",
	"./vincenzo.png": "./src/assets/img/new_alpha/characters/vincenzo.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img/new_alpha/characters sync recursive ^\\.\\/.*\\.png$";